module.exports = __webpack_public_path__ + "img/ic-loading-signal-only.55527583.svg";